'use client'
import { useTranslation } from '@/hooks/useTranslation'
import { useLocale } from '@/context/LocaleContext'

const CookieManagerBtn = () => {
  const locale = useLocale()
  const { t } = useTranslation(locale)

  return (
    <div className="text-sm text-primary-ink-30">
      <button
        onClick={() => {
          if (typeof window !== 'undefined' && window.Osano) {
            const showDrawer = () => window.Osano?.cm?.showDrawer('osano-cm-dom-info-dialog-open')
            // Before osano.js sets up, window.Osano is its command queue (see utils/consent.ts).
            if (window.Osano.cm) showDrawer()
            else window.Osano('onInitialized', showDrawer)
          }
        }}
        className="cursor-pointer"
      >
        {t('cookie_manager')}
      </button>
    </div>
  )
}

export default CookieManagerBtn
